import { render, staticRenderFns } from "./AgreementDocumentView.vue?vue&type=template&id=c81c8830&scoped=true"
import script from "./AgreementDocumentView.vue?vue&type=script&lang=js"
export * from "./AgreementDocumentView.vue?vue&type=script&lang=js"
import style0 from "./AgreementDocumentView.vue?vue&type=style&index=0&id=c81c8830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81c8830",
  null
  
)

export default component.exports